import MultiSelect from './MultiSelect';
import FilterableMultiSelect from './FilterableMultiSelect';
MultiSelect.Filterable = FilterableMultiSelect;
export default MultiSelect;


//////////////////
// WEBPACK FOOTER
// ./node_modules/carbon-components-react/es/components/MultiSelect/index.js
// module id = 1293
// module chunks = 0